import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const UserCrossDelete = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M17.6 6.39999L20.1 3.89999" />
      <path d="M20.1 6.39999L17.6 3.89999" />
      <path d="M7.5 16C7.89691 15.0894 8.7956 14.5005 9.78894 14.5H14.2111C15.2044 14.5005 16.1031 15.0894 16.5 16" />
      <circle cx="12" cy="9.5" r="2.5" />
      <path d="M14 3.23071C10.0757 2.32602 6.02682 4.12986 4.07495 7.65243C2.12309 11.175 2.74033 15.5644 5.58798 18.412C8.43564 21.2597 12.825 21.8769 16.3476 19.925C19.8701 17.9732 21.674 13.9242 20.7693 9.99999" />
    </svg>
  );
};
